import { Colors, colors } from '@gripp/shared-ui';
import { StyleSheet } from 'react-native';

export const filesSharedStyles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: Colors.role.canvas,
    padding: 16,
  },
  scrollView: {
    flex: 1,
  },
  headerActions: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  videoPanelCenter: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: Colors.role.canvas,
  },
  galleryPanel: {
    flex: 1,
    backgroundColor: Colors.role.canvas,
    overflow: 'hidden',
    padding: 16,
    maxHeight: 'calc(100vh - 75px)' as unknown as number,
  },
});
